import * as FetchHttpClient from 'effect/unstable/http/FetchHttpClient';

/**
 * The HTTP client that a browser runtime reads through: the Fetch API.
 *
 * The engine client layer and a tenant browser runtime both take the client
 * from this layer. A tenant package names no HTTP client module
 * (`tools/guards/httpImportBoundary.ts`).
 */
export const HttpClientLayer = FetchHttpClient.layer;
